import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { QueryParamsHelper } from '@shared/helpers';
import { Pagination } from '@ui-kit/miscs';
import { TableColumn, tablePageSizeOptions } from '@ui-kit/table/_core';
import { feeWaiversTableConfig } from '../misc';
import { FeeWaiversOperations, FeeWaiversQPEnum, FeeWaiversTableColumnEnum } from '../types';

@Injectable({ providedIn: 'root' })
export class FeeWaiversQPService {
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);

    setColumnsQueryPrams(columns: TableColumn<FeeWaiversTableColumnEnum>[]): void {
        this.router.navigate([], QueryParamsHelper.columnsRouterOptions(this.activatedRoute, columns));
    }

    getOperationsFromQueryParams(params: Params, operations: FeeWaiversOperations): FeeWaiversOperations {
        if (params[FeeWaiversQPEnum.SEARCH]) {
            operations.searchValue = params[FeeWaiversQPEnum.SEARCH];
        }

        if (params[FeeWaiversQPEnum.SIZE]) {
            const pagination = QueryParamsHelper.readPaginationQueryParams(params, tablePageSizeOptions);
            operations.pagination.take = pagination.take;
            operations.pagination.skip = pagination.skip;
        }

        if (params[FeeWaiversQPEnum.COLUMNS]) {
            operations.columns = QueryParamsHelper.readColumnsQueryParams(
                params[FeeWaiversQPEnum.COLUMNS],
                operations.columns,
                feeWaiversTableConfig().columns
            );
        }

        return operations;
    }

    setPaginationQueryParams(pagination: Pagination): void {
        this.router.navigate([], QueryParamsHelper.paginationRouterOptions(this.activatedRoute, pagination));
    }

    setSearchQueryParams(searchValue: string, pagination: Pagination): void {
        this.router.navigate([], QueryParamsHelper.searchRouterOptions(this.activatedRoute, searchValue, pagination));
    }
}
